/**
 * Author: Andrey Morozov
 * Confidential. Proprietary code. Do not distribute without authorization.
 *
 * calls.ts — calls (services/operator-web-app).
 */

/**
 * Calls API (web-ui backend: GET /api/calls, GET /api/calls/:id).
 */

import { apiGet } from './client';

export interface CallSummaryMeeting {
  date?: string;
  time?: string;
  location?: string;
  person?: string;
  topic?: string;
}

export interface CallSummaryPayload {
  summary?: string;
  agreements?: string[];
  meetings?: CallSummaryMeeting[];
  generated_at?: number;
}

export interface CallListItem {
  call_id: string;
  session_id?: string;
  caller_id?: string;
  callee_id?: string;
  status: string;
  start_time: number;
  end_time?: number;
  duration_ms?: number;
  last_event?: unknown;
  is_bridged?: boolean;
  operator_call_id?: string;
  operator_uri?: string;
  scenario_name?: string;
  current_step?: string;
  end_reason?: string;
  intents?: string[];
  hints?: string[];
  risk_score?: number;
  risk_level?: string;
  primary_issue?: string;
  last_intent?: string;
  last_intent_score?: number;
  summary?: CallSummaryPayload;
}

export interface CallsListResponse {
  calls: CallListItem[];
  total: number;
  limit: number;
  offset: number;
}

export interface CallDetailResponse {
  call: CallListItem;
  events: Array<{
    event_type: string;
    timestamp: number;
    seq_no: number;
    data: Record<string, unknown>;
    intent?: string;
    intent_score?: number;
    text?: string;
    recipient?: string;
    role?: string;
  }>;
}

const CALLS_PREFIX = '/api/calls';

export async function fetchCallsList(params?: {
  status?: string;
  search?: string;
  limit?: number;
  offset?: number;
}): Promise<CallsListResponse> {
  const q: Record<string, string> = {};
  if (params?.status) q.status = params.status;
  if (params?.search) q.search = params.search;
  if (params?.limit != null) q.limit = String(params.limit);
  if (params?.offset != null) q.offset = String(params.offset);
  return apiGet<CallsListResponse>(CALLS_PREFIX, Object.keys(q).length ? q : undefined);
}

export async function fetchCallDetail(callId: string): Promise<CallDetailResponse> {
  return apiGet<CallDetailResponse>(`${CALLS_PREFIX}/${callId}`);
}
